import { ESSENTIAL_SECTIONS } from './essentials';
import { CAREER_SECTIONS } from './career';
import { LEADERSHIP_SECTIONS } from './leadership';
import { ACADEMIC_SECTIONS } from './academic';
import { PERSONAL_SECTIONS } from './personal';
import { CUSTOM_SECTIONS } from './custom';

export const SECTION_REGISTRY = [
  ...ESSENTIAL_SECTIONS,
  ...CAREER_SECTIONS,
  ...LEADERSHIP_SECTIONS,
  ...ACADEMIC_SECTIONS,
  ...PERSONAL_SECTIONS,
  ...CUSTOM_SECTIONS
];

export function getRegistryItem(sectionId) {
  if (sectionId.startsWith('custom')) {
    const customBase = CUSTOM_SECTIONS[0];
    return {
      ...customBase,
      id: sectionId
    };
  }
  return SECTION_REGISTRY.find(s => s.id === sectionId) || null;
}
